var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPollRounded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72396 3.97599C6.55147 2.14849 9.18336 1.24182 12.3977 1.24182C15.6119 1.24182 18.2438 2.14849 20.0713 3.97599C21.8988 5.80349 22.8055 8.43538 22.8055 11.6497C22.8055 14.864 21.8988 17.4959 20.0713 19.3234C18.2541 21.1406 15.6414 22.0473 12.4517 22.0574C12.4338 22.0586 12.4158 22.0591 12.3977 22.0591C10.6383 22.0591 9.05449 21.7889 7.67824 21.241L3.48464 22.6393C3.19023 22.7374 2.87389 22.7506 2.57237 22.6773C2.27084 22.6039 1.9961 22.4471 1.77963 22.2248C1.56315 22.0024 1.41372 21.7236 1.34845 21.4202C1.28319 21.1169 1.30474 20.8012 1.41063 20.5095L2.86384 16.5095C2.27872 15.1016 1.9898 13.4694 1.9898 11.6497C1.9898 8.43538 2.89646 5.80349 4.72396 3.97599ZM12.3465 20.349C12.3634 20.348 12.3805 20.3475 12.3977 20.3475C15.2972 20.3475 17.4417 19.5347 18.8622 18.1142C20.2827 16.6937 21.0955 14.5492 21.0955 11.6497C21.0955 8.75014 20.2827 6.60561 18.8622 5.18514C17.4417 3.76467 15.2972 2.95182 12.3977 2.95182C9.49812 2.95182 7.35359 3.76467 5.93312 5.18514C4.51265 6.60561 3.6998 8.75014 3.6998 11.6497C3.6998 13.4219 4.00365 14.9124 4.56082 16.1227C4.65496 16.3272 4.66465 16.5606 4.58777 16.7722L3.05961 20.9785L7.44152 19.5174C7.64264 19.4503 7.8615 19.4603 8.05562 19.5455C9.23053 20.0613 10.6602 20.3435 12.3465 20.349Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00051 15.8551C7.5283 15.8551 7.14551 15.4723 7.14551 15.0001L7.14551 10.0001C7.14551 9.5279 7.5283 9.1451 8.00051 9.1451C8.47271 9.1451 8.85551 9.5279 8.85551 10.0001L8.85551 15.0001C8.85551 15.4723 8.47271 15.8551 8.00051 15.8551Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7105 15.8551C11.2383 15.8551 10.8555 15.4723 10.8555 15.0001V7.0001C10.8555 6.5279 11.2383 6.1451 11.7105 6.1451C12.1827 6.1451 12.5655 6.5279 12.5655 7.0001V15.0001C12.5655 15.4723 12.1827 15.8551 11.7105 15.8551Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4205 15.8551C14.9483 15.8551 14.5655 15.4723 14.5655 15.0001V10.0001C14.5655 9.5279 14.9483 9.1451 15.4205 9.1451C15.8927 9.1451 16.2755 9.5279 16.2755 10.0001V15.0001C16.2755 15.4723 15.8927 15.8551 15.4205 15.8551Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPollRounded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPollRounded.f6e1de04b55c7eade7f8060e4330e5dd.svg";